module.exports = __webpack_public_path__ + "img/eae-slide-10.746181a2.jpg";